<template>
    <div>-</div>
</template>

<script>
    export default {
        name: 'blank-summary',
    };
</script>
